<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="PROPERTY_RATES_DEFAULTERS">{{"PROPERTY_RATES_DEFAULTERS" | translate}}</h4>
    </div>
    <button
      class="button is-info"
      [disabled]="isLoading"
      (click)="createReport()"
      [ngClass]="{ 'is-loading': isLoading }"
      translationEditableDirective="GENERATE_REPORT"
    >
      {{"GENERATE_REPORT" | translate}}
    </button>
  </div>
</div>
